/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationPatientDto
 */
export interface ConversationPatientDto {
    /**
     * Patient ID
     * @type {string}
     * @memberof ConversationPatientDto
     */
    patientId: string;
    /**
     * Patient first name
     * @type {string}
     * @memberof ConversationPatientDto
     */
    firstName: string;
    /**
     * Patient last name
     * @type {string}
     * @memberof ConversationPatientDto
     */
    lastName: string;
    /**
     * Patient photo URL
     * @type {string}
     * @memberof ConversationPatientDto
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the ConversationPatientDto interface.
 */
export function instanceOfConversationPatientDto(value: object): value is ConversationPatientDto {
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ConversationPatientDtoFromJSON(json: any): ConversationPatientDto {
    return ConversationPatientDtoFromJSONTyped(json, false);
}

export function ConversationPatientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationPatientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patientId': json['patientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function ConversationPatientDtoToJSON(json: any): ConversationPatientDto {
    return ConversationPatientDtoToJSONTyped(json, false);
}

export function ConversationPatientDtoToJSONTyped(value?: ConversationPatientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patientId': value['patientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'photoUrl': value['photoUrl'],
    };
}

